Number.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' &&
    isFinite(value) &&
    Math.floor(value) === value
}


// WEBPACK FOOTER //
// ./src/common/general/js/polyfills/Number.isInteger.js